import { AppConfig } from "../common/appConfig";
import toastr from 'toastr';
import * as Sentry from "@sentry/react";
import React from "react";

//clase base para las peticiones HTTP
export class ApiBaselegacy {

    token = ''; // Token temporal que genera el backend
    baseUrl = AppConfig.API_URL; // Url base del endpoint

    createUrlFromRoot(relativeUrl) {
        return `${this.baseUrl}/${relativeUrl}`;
    }

    getHeaders() {
        return {
            'Accept': 'application/json; odata=verbose',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${this.token}` || ''
        };
    }

    // Ahora handleError es async para poder leer el cuerpo del error
async handleError(response) {
    if (response.status) {
        let errorMessage = "";
        try {
            const data = await response.json();
            errorMessage = data?.mensaje || JSON.stringify(data);
        } catch {
            errorMessage = await response.text(); // fallback por si no es JSON
        }

        // Armar mensaje estándar para lanzar, sin mostrar toast aquí
        let fullMessage = `${response.status}: ${errorMessage}`;

        switch (response.status) {
            case 400:
                console.error("Bad request:", errorMessage);
                Sentry.captureException(new Error(`400 api: ${response.url}`), {
                    level: "warning",
                    tags: { url: response.url }
                });
                throw new Error(fullMessage);

            case 401:
                Sentry.captureException(new Error("401 Cerrar sesión"), {
                    level: "warning"
                });
                throw new Error("401: No autorizado");

            case 404:
                throw new Error("404: Recurso no encontrado");

            case 412:
                Sentry.captureException(new Error("412 Precondition failed"), {
                    level: "warning"
                });
                throw new Error("412: Condición previa fallida");

            case 500:
                Sentry.captureException(new Error("500: " + response.statusText), {
                    level: "warning"
                });
                throw new Error("500: " + (response.statusText || "Error interno del servidor"));

            default:
                throw new Error(fullMessage);
        }
    } else {
        throw new Error("Sin respuesta del servidor");
    }
}

    async getApiToken() {
        const url = this.createUrlFromRoot('AuthToken');
        try {
            let response = await fetch(url, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    Key: AppConfig.KEY,
                    ApiKey: AppConfig.API_KEY
                })
            });
            if (!response.ok) await this.handleError(response);

            const data = await response.json();
            this.token = data.apiTkn;
            return data;
        } catch (e) {
            throw e;
        }
    }

    async post(urlFromRoot, request) {
        await this.getApiToken();
        const url = this.createUrlFromRoot(urlFromRoot);
        try {
            let response = await fetch(url, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(request)
            });
            if (!response.ok) await this.handleError(response);

            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    async get(urlFromRoot) {
        await this.getApiToken();
        const url = this.createUrlFromRoot(urlFromRoot);
        try {
            let response = await fetch(url, {
                method: 'GET',
                headers: this.getHeaders()
            });
            if (!response.ok) await this.handleError(response);

            return await response.json();
        } catch (error) {
            throw error;
        }
    }

}
